import { render, staticRenderFns } from "./UploadFile.vue?vue&type=template&id=b36bb804&"
import script from "./UploadFile.vue?vue&type=script&lang=js&"
export * from "./UploadFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b36bb804')) {
      api.createRecord('b36bb804', component.options)
    } else {
      api.reload('b36bb804', component.options)
    }
    module.hot.accept("./UploadFile.vue?vue&type=template&id=b36bb804&", function () {
      api.rerender('b36bb804', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/_vue/componentes/UploadFile.vue"
export default component.exports